import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { LocalStorage } from "../utils/storage/LocalStorage";
import { StorageKeys, AuthStorage } from "../utils/auth/AuthStorage";

const graphQlUrl = process.env.REACT_APP_GRAPHQL
if (!graphQlUrl) {
  throw new Error("A variável de ambiente REACT_APP_GRAPHQL não está definida")
}

const httpLink = new HttpLink({
  uri: graphQlUrl
})

const authLink = new ApolloLink((operation, forward) => {
  try {
    const accessToken = LocalStorage.getItem(StorageKeys.AccessToken)
  
    if (accessToken) {
      operation.setContext({
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    }
  } catch(e) {}

  return forward(operation)
})

let isRedirecting = false
let redirectTimer: ReturnType<typeof setTimeout> | null = null

function handleAuthError() {
  if (isRedirecting) return
  isRedirecting = true
  if (redirectTimer) clearTimeout(redirectTimer)
  redirectTimer = setTimeout(() => { isRedirecting = false }, 3000)
  AuthStorage.logout()
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (isRedirecting) return

  if (graphQLErrors) {
    for (const error of graphQLErrors) {
      const { message, extensions } = error
      if (extensions?.code === 'UNAUTHENTICATED' ||
          message.toLowerCase().includes('unauthorized') ||
          message.toLowerCase().includes('token') ||
          message.toLowerCase().includes('expired')) {
        handleAuthError()
        return
      }
    }
  }

  if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
    handleAuthError()
  }
})

export const graphQlClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
})
